// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1C4t5","label":"LabeledBox_label__2uN2j"};